module.exports = __webpack_public_path__ + "img/fb.04fdfabf.svg";